// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 179) return "dentolo.css";
	// return url for filenames based on template
	return "" + chunkId + "." + "5275468c490a5ac4941e" + ".chunk.css";
};